const toHoursAndMinutes = (value) => {
  if (value === null || value === undefined || value === '') return null

  if (typeof value === 'number' && Number.isFinite(value)) {
    let hours = Math.floor(Math.max(0, value))
    let minutes = Math.round((Math.max(0, value) - hours) * 60)

    if (minutes === 60) {
      hours += 1
      minutes = 0
    }

    return { hours, minutes }
  }

  const text = String(value).trim()
  if (!text) return null

  const hhmmMatch = text.match(/^(\d{1,4})\s*:\s*(\d{1,2})(?:\s*:\s*(\d{1,2}))?$/)
  if (hhmmMatch) {
    let hours = Number(hhmmMatch[1])
    let minutes = Number(hhmmMatch[2])
    const seconds = Number(hhmmMatch[3] || 0)

    if (seconds >= 30) minutes += 1

    if (minutes >= 60) {
      hours += Math.floor(minutes / 60)
      minutes %= 60
    }

    return { hours, minutes }
  }

  const numericMatch = text.match(/^(\d+(?:[.,]\d+)?)\s*(?:h|hora|horas)?$/i)
  if (numericMatch) {
    const numericValue = Number(numericMatch[1].replace(',', '.'))
    if (Number.isFinite(numericValue)) {
      let hours = Math.floor(Math.max(0, numericValue))
      let minutes = Math.round((Math.max(0, numericValue) - hours) * 60)

      if (minutes === 60) {
        hours += 1
        minutes = 0
      }

      return { hours, minutes }
    }
  }

  if (text.includes(':')) return null

  const digitsOnly = text.replace(/[^\d]/g, '')
  if (!digitsOnly) return null

  return { hours: Number(digitsOnly), minutes: 0 }
}

export const formatCourseWorkloadHHMM = (value) => {
  const parsed = toHoursAndMinutes(value)
  if (!parsed) return ''

  const hours = String(parsed.hours).padStart(2, '0')
  const minutes = String(parsed.minutes).padStart(2, '0')
  return `${hours}:${minutes}`
}

export const normalizeCourseWorkloadInput = (value) => {
  const sanitized = String(value || '').replace(/[^\d:]/g, '')
  if (!sanitized) return ''

  const [rawHours = '', rawMinutes = ''] = sanitized.split(':')
  const hours = rawHours.replace(/\D/g, '').slice(0, 4)
  const minutes = rawMinutes.replace(/\D/g, '').slice(0, 2)

  if (!sanitized.includes(':')) return hours
  return `${hours}:${minutes}`
}

export const serializeCourseWorkloadValue = (value) => {
  const parsed = toHoursAndMinutes(value)
  if (!parsed) return ''

  const decimalHours = parsed.hours + parsed.minutes / 60
  return decimalHours.toFixed(6).replace(/\.?0+$/, '')
}
